import React from 'react'

import { connect } from 'react-redux'

import {
  translate,
  defaultTheme,
  ViewTitle,
  SimpleShowLayout,
  SimpleForm,
  SelectInput,
} from 'admin-on-rest'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'

import Toggle from 'material-ui/Toggle'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'

import * as moment from 'moment'

import { updateAttendance, updateGrade } from '../reducers'
import { getStudentName } from '../helpers'

class InstructorCoursePageConfirmedList extends React.Component {
  getPaymentType(payments, studentId) {
    return payments && payments.hasOwnProperty(studentId)
      ? payments[studentId].receipt
        ? 'Chitanta'
        : 'Card online'
      : ''
  }

  render() {
    const { course, courseId, students } = this.props

    return (
      <div>
        <ViewTitle title="Cursanti confirmati (curs achitat)" />
        <Table selectable={false}>
          <TableHeader
            enableSelectAll={false}
            adjustForCheckbox={false}
            displaySelectAll={false}
          >
            <TableRow>
              <TableHeaderColumn>Cursant</TableHeaderColumn>
              <TableHeaderColumn>Plata</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {students.map(student => {
              return (
                <TableRow key={student.id}>
                  <TableRowColumn>{getStudentName(student)}</TableRowColumn>
                  <TableRowColumn>
                    {this.getPaymentType(course.payments, student.id)}
                  </TableRowColumn>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    )
  }
}

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
}

export default connect(null, { updateAttendance, updateGrade })(
  InstructorCoursePageConfirmedList,
)



// WEBPACK FOOTER //
// ./src/instructors/InstructorCoursePageConfirmedList.js